import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{staticClass:"pa-5"},[_c(VCardTitle,[_vm._v("Gerador de UUIDs para QR Codes")]),_c(VCardText,[_c(VTextField,{attrs:{"label":"Quantidade de UUIDs","type":"number"},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}),_c(VBtn,{on:{"click":_vm.generateUUIDs}},[_vm._v("Gerar UUIDs")]),_c(VTextarea,{attrs:{"label":"UUIDs gerados","rows":10,"auto-grow":""},model:{value:(_vm.output),callback:function ($$v) {_vm.output=$$v},expression:"output"}})],1)],1),_c('Snackbar',{ref:"chamaSnackbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }